module.exports = {
    "Clear search": `Limpar pesquisa`
};


//# sourceMappingURL=pt-BR.main.js.map
